<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'orderValueChart',
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  data() {
    return {
      customOptions: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return `$${Math.round(value * 100) / 100}`
            },
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Value of Orders (USD $)',
              },
              ticks: {
                suggestedMin: 0,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Date',
              },
            },
          ],
        },
      },
    }
  },
  methods: {
    moldChartData: function () {
      const orders = this.chartData.orders
      const days = {}
      for (let i = 0; i < orders.length; i++) {
        const date = orders[i].created
        const stringDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

        if (days[stringDate] === undefined || days[stringDate] === null) {
          days[stringDate] = 0
        }

        days[stringDate] += orders[i].total_order_value
      }

      // Sort the data so that the dates are accending
      const labels = Object.keys(days)
      labels.sort((a, b) => {
        return new Date(a) - new Date(b)
      })
      const data = []
      labels.forEach((date) => {
        data.push(days[date])
      })

      const newChartData = {
        labels: labels,
        datasets: [
          {
            label: 'Value of Orders',
            data: data,
            fill: false,
            borderColor: this.$themes.secondary,
          },
        ],
      }
      return newChartData
    },
  },
  mounted() {
    const newChartData = this.moldChartData()

    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(newChartData, this.customOptions)
  },
  watch: {
    chartData() {
      const newChartData = this.moldChartData()
      this.$data._chart.destroy()
      this.renderChart(newChartData, this.customOptions)
    },
  },
}
</script>

<style lang="scss">
</style>
